import { render } from "./ExternalTranslation.vue?vue&type=template&id=7d195a33&scoped=true&ts=true"
import script from "./ExternalTranslation.vue?vue&type=script&lang=ts"
export * from "./ExternalTranslation.vue?vue&type=script&lang=ts"

import "./ExternalTranslation.vue?vue&type=style&index=0&id=7d195a33&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d195a33"]])

export default __exports__